module.exports = __webpack_public_path__ + "static/media/VectorMap.96953a8c.png";